module.exports = __webpack_public_path__ + "img/4.8880a7b0.png";